import {
  CONST_PROJECT_STATUS_LIST,
  CONST_PROJECT_STATUS_TIMELINE_GROUPS,
} from "../../../../constants/lists";
import {
  ENUM_PROJECT_STATUS,
  ENUM_PROJECT_STATUS_CATEGORY,
} from "../../../../enums";
import { isSelectedTimeSlotPast } from "../../../../services/date-and-time.utils";

export function getTimelineState(status?: string) {
  const statusConfig = status ? CONST_PROJECT_STATUS_LIST[status] : null;
  const category =
    statusConfig?.category ?? ENUM_PROJECT_STATUS_CATEGORY.NEW;
  const activeStepIndex = CONST_PROJECT_STATUS_TIMELINE_GROUPS.findIndex(
    (group) => group.category === category
  );
  const isClosedStatus = Boolean(statusConfig?.isClosedStatus);
  const isPastSuccess =
    category === ENUM_PROJECT_STATUS_CATEGORY.PAST && !isClosedStatus;

  return {
    activeStepIndex: activeStepIndex >= 0 ? activeStepIndex : 0,
    isClosedStatus,
    isPastSuccess,
  };
}

export function canShowSendMeetingReminder(data?: {
  invitationStatus?: string;
  status?: string;
  selectedTimeSlot?: { from?: string; to?: string };
  zoomURL?: string;
  isCompleted?: boolean;
  isRejected?: boolean;
}) {
  const status = data?.invitationStatus ?? data?.status;
  const statusConfig = status ? CONST_PROJECT_STATUS_LIST[status] : null;

  if (
    !data?.selectedTimeSlot?.from ||
    status === ENUM_PROJECT_STATUS.ARCHIVE ||
    statusConfig?.isClosedStatus ||
    isSelectedTimeSlotPast(data.selectedTimeSlot)
  ) {
    return false;
  }

  if (status) {
    const scheduledStep =
      CONST_PROJECT_STATUS_LIST[ENUM_PROJECT_STATUS.SEND_MEETING_LINK]?.step ??
      5;

    return (statusConfig?.step ?? 0) >= scheduledStep;
  }

  // Dashboard calendar events may omit invitation status.
  if (data?.isCompleted || data?.isRejected) {
    return false;
  }

  return Boolean(data?.zoomURL);
}
